import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Form from "./form";
import Input from "./input";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Radio from "./radio";
import Title from "./title";

export default function Alliance({ mediaQuery }) {
  const nextUrl = "/apply/acknowledge-commitment/";
  const submitUrl = "/api/applications/v4/application/alliance/";
  const {
    data: {
      alliance_clubs,
      membership_price: _price,
      results: [
        { submission: { alliance, membership_price: __price } } = {
          submission: { alliance: { alliance: null }, membership_price: { annual_fee_amt: null } }
        }
      ]
    }
  } = useQuery(["application"]);
  const membership_price = _price || __price;
  const defaultValue =
    alliance.alliance === null
      ? { errors: null, reason: "", alliance: true }
      : { errors: null, reason: "", ...alliance };
  const [form, setForm] = useState(defaultValue);
  const alliance_price = 900;
  const annual_fee_amt = Number(membership_price.annual_fee_amt);
  const alliance_choice_name = `The Battery ($${annual_fee_amt}) + The Battery Alliance ($${alliance_price})`;
  const alliance_choice_detail = `$${annual_fee_amt + alliance_price} / year`;
  const battery_choice_detail = `$${annual_fee_amt} / year`;
  const choices = [
    {
      id: true,
      name: alliance_choice_name,
      description: "Access to The Battery and 60+ additional private clubs worldwide",
      detail: alliance_choice_detail,
      extra: (
        <>
          <P style={{ textAlign: "left", margin: "0 2rem 1rem 2rem" }}>
            Since our humble beginnings in 2013, The Battery has strived to be a home away from home
            for all of our Members. We&apos;ve designed the club to reflect all the Bay Area
            provides. But what to do when you&apos;re traveling? How do you experience local flavor
            coupled with the high-touch service that a club offers? We&apos;ve partnered with over
            60 of the world&apos;s best clubs, a program we call The Battery Alliance, in order to
            bring you similar experiences in more than 20+ countries. Breakfast in Barcelona, Lunch
            in London, or Dinner in Dallas - Battery Alliance brings the same local touch that
            you&apos;re seeking from The Battery, abroad.
          </P>
          <P style={{ textAlign: "left", margin: "0 2rem 1rem 2rem" }}>
            Your Alliance membership will renew alongside your Battery membership and get you nearly
            unlimited access to clubs around the world. Simply log-on, request a visit, and
            you&apos;ll be sipping in Singapore in no-time.
          </P>
          <div
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: mediaQuery.isTabletOrMobile
                ? "repeat(auto-fill, 246px)"
                : "repeat(auto-fill, 147px)",
              padding: mediaQuery.isTabletOrMobile ? "0 1rem 1rem 1rem" : "0 2rem 2rem 2rem"
            }}
          >
            {alliance_clubs.data.map((n, idx) => (
              <div key={idx}>
                <div style={{ marginBottom: ".5rem" }}>
                  <a href={n.websiteUrl} target="_blank" rel="noreferrer">
                    <img
                      src={`${n.location.images["square"]}-/resize/294x/-/quality/smart_retina/-/format/auto/`}
                      style={{ width: "100%", height: "100%", borderRadius: "5%" }}
                      alt={n.name}
                    />
                  </a>
                </div>
                <div style={{ fontSize: 12, textAlign: "left" }}>
                  <a href={n.websiteUrl} target="_blank" rel="noreferrer">
                    <span style={{ fontSize: ".8rem" }}>{n.location.location_name}</span>
                    <br />
                    <span style={{ opacity: 0.5 }}> {n.location.city_country}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </>
      )
    },
    {
      id: false,
      name: "The Battery",
      description: "Access to The Battery only",
      detail: battery_choice_detail,
      extra: (
        <>
          {form.alliance === false && (
            <>
              <P style={{ textAlign: "left", margin: "0 2rem 0 2rem" }}>
                Battery Alliance is a brand new offering, it would help us greatly if you could tell
                us why you chose not to include Battery Alliance as part of your membership:
              </P>
              <Input
                form={form}
                name="reason"
                placeholder="Reason for opting out"
                setForm={setForm}
                style={{ padding: "1rem" }}
                value={form.reason}
              />
            </>
          )}
        </>
      )
    }
  ];
  return (
    <Page>
      <PageHeader title="time to explore" tagline="Want even more?">
        <P>
          The Battery has partnered with the world’s best private clubs, a network we call The
          Battery Alliance. If you choose to add on the The Battery Alliance, you’ll have full
          access to over 60+ private clubs in 20+ countries.
        </P>
      </PageHeader>
      <Title>select an Option</Title>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} submitUrl={submitUrl}>
        <Radio fullWidth={true} choices={choices} name="alliance" form={form} setForm={setForm} />
      </Form>
    </Page>
  );
}
